module.exports = __webpack_public_path__ + "img/manapro.76c3ce05.jpeg";